export const createScopedActions =
    (functionsMap: $TSFixMe, { scopeName = 'scope' } = {}) =>
    (dispatch: $TSFixMe, props: $TSFixMe) => {
        const scope = props[scopeName];

        if (!scope) {
            throw new TypeError(`Expected scope to be string, instead got: '${scope}'`);
        }

        return Object.keys(functionsMap).reduce((acc, key) => {
            const fn = functionsMap[key];

            if (typeof fn !== 'function') {
                throw new TypeError(`Expected '${key}' to be a function, instead got: '${fn}'`);
            }
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            acc[key] = (...args: $TSFixMe[]) => dispatch(fn(...args, scope));
            return acc;
        }, {});
    };
